var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"my-prop"},[_c('comHead',{attrs:{"headObj":_vm.headObj}}),_vm._v(" "),_c('caikuangExchangeList',{attrs:{"from":'prop',"list":_vm.list,"institutional":_vm.institutional},on:{"catNameFnc":_vm.catNameFnc}})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-6c020386","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/view/myProp/index.vue
// module id = null
// module chunks = 